import { Messages } from '../../../../codegen/Localize';
import { setTabs } from '../../../../workbook/actions/SetTabsWorkbookAction';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const SetDisplayTabsAction: IEntityAction<IContentInfo, { setDisplayTabs: boolean }> = {
  name: EntityActionNames.SetDisplayTabs,
  translateName: Messages.setDisplayTabs_action,
  isVisible: () => true,
  isClickable: (availableActions: { setDisplayTabs: boolean }) => !!(availableActions && availableActions.setDisplayTabs),
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.every(item => item.contentType === 'workbook')) {
      return setTabs(targetItems);
    } else {
      return null;
    }
  }
};
